// extracted by mini-css-extract-plugin
export var badge = "_gn-2";
export var detailsPanel = "_gn-0";
export var resultRow = "_gn-1";